import { Injectable } from '@angular/core';
import { GraphqlService } from './graphql.service';

@Injectable({
  providedIn: 'root',
})
export class SharedGraphQlService extends GraphqlService {
  constructor() {
    super();
  }
}
